import {TOGGLE_MODAL, CLOSE_ALL_MODALS} from "../constants/action-types";

export default (
  modals = {
    realism: false,
    pictures: false,
    threeDPreview: false
  },
  action
) => {
  const {type, payload} = action;

  switch (type) {
    case TOGGLE_MODAL:
      return {...modals, [payload.modal]: !modals[payload.modal]};

    case CLOSE_ALL_MODALS:
      return Object.keys(modals).reduce((acc, key) => {
        return {...acc, [key]: false};
      }, {});
  }

  return modals;
};
